<template>
  <w-sliding-popup type="setting" ref="slidingPopup" :default-content="false" title="대용량 파일 생성 감시 그룹 저장" @close="close">
    <div slot="content" class="body-content" style="width:100%; height:100%;">
      <el-row :gutter="15" style="height: 100%;">
        <el-col :span="10" style="height: 100%;">
          <w-common-obj-list ref="commonObjList" style="width:100%; height: calc(100% - 39px);" type="physical" selected-managetype-id="SMS" :fit-height="true"/>
        </el-col>
        <el-col :span="14" style="height: 100%;">
          <div class="title-bar title-h3">선택 정보 목록</div>
          <el-table-wrapper style="width:100%; height: calc(100% - 30px);" fit-height :data="dataList" :columns="fileDetectColumns" :column-default="columnDefault">
          </el-table-wrapper>
        </el-col>
      </el-row>
    </div>
    <el-row slot="footer" type="flex" justify="center">
      <el-button class="mr-r4" size="large" type="solid" @click="fileChangeSaveGroup">저장</el-button>
      <el-button size="large" @click="closePopup">취소</el-button>
    </el-row>
  </w-sliding-popup>
</template>

<script>
import { map, cloneDeep } from 'lodash';
import { columnDefault } from '@/constants/table';
import msgUtil from '@/utils/message';
import WCheckPhysicalTree from '@/components/tree/CheckPhysicalTree';
import ServerSettingAPI from '@/api/settings/server/server-settings';
import WCommonObjList from '@/components/table/CommonObjList';

export default {
  name: 'WBulkCreateSaveGroupPopup',
  components: {
    WCheckPhysicalTree,
    WCommonObjList,
  },
  props: {
    changeCheckList: Array,
  },
  data() {
    return {
      serverIdList: [],
      dataList: null,
      columnDefault,
      fileDetectColumns: [
        {
          prop: 'path',
          label: '디렉토리 명',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'detectFileSize',
          label: '감시 크기 설정(MB)',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
          width: 150,
        },
      ],
    };
  },
  watch: {
    changeCheckList: {
      handler() {
        this.dataList = this.changeCheckList;
      },
    },
  },
  methods: {
    close() {
      this.$refs.commonObjList.initData();
    },
    closePopup() {
      this.$refs.slidingPopup.visible = false;
    },
    fileChangeSaveGroup() {
      // 트리에 체크된 아이들을 가져와서 serverId list에 저장한다.
      const checkServerList = this.$refs.commonObjList.getSelectedObjList();
      const uniqServerIds = map(checkServerList, 'serverId');
      const saveGroupList = [];
      this.dataList.forEach((item) => {
        uniqServerIds.forEach((serverId) => {
          if (serverId !== item.serverId) {
            const saveItem = cloneDeep(item);
            saveItem.serverId = serverId;
            saveGroupList.push(saveItem);
          }
        });
      });
      const target = '감시 디렉토리';
      const action = msgUtil.action.SAVE;
      ServerSettingAPI.insertDetectFilelistGroup(saveGroupList).then((response) => {
        if (response.data.success) {
          this.$message(msgUtil.getResultMsgData(action, target, true));
          this.$emit('reload-data');
          this.closePopup();
        } else {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(action, target, false));
      });
    },
    open() {
      this.$refs.slidingPopup.open();
      this.$emit('open');
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/server/FileDetectSettings/BulkFileCreateView/popup/BulkCreateGroupSavePopup.vue